import { render, staticRenderFns } from "./PageNoDropDownSelector.vue?vue&type=template&id=642ec0f8&scoped=true&"
import script from "./PageNoDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./PageNoDropDownSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ec0f8",
  null
  
)

export default component.exports